export default __webpack_public_path__ + "static/media/information--minimum-speed-40--g1.3414f977.png";